<template>
  <div class="demo-outer" id="#demo">
    <div class="demo">
      <div class="demo-head">
        <div class="status-bar">
          <svgStatusBarIcons />
        </div>
        <div class="title-bar">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.8 12L19.4 5.4L18 4L10 12L18 20L19.4 18.6L13 12.2L12.8 12Z" fill="white"/>
          </svg>
          <div class="title">
            채팅+
          </div>
        </div>
      </div>
      <div class="demo-body">
        <DemoChat 
          :messages="messages"
          ref="chat"
        />
      </div>
      <div class="demo-foot">
        <DemoEmoji 
          :currentTab="currentTab"
          v-on:selectTab="setTab"
          v-on:selectMessage="selectMessage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import svgStatusBarIcons from '@/svg/svgStatusBarIcons'
import DemoEmoji from './DemoEmoji'
import DemoChat from './DemoChat'

export default {
  data() {
    return {
      lastMessageId: 0,
      messages: [],
      currentTab: 'bear',
      bird: [
        { answer: "나 집이야!" },
        { answer: "나도 사랑해❤️" },
        { answer: "나 그냥 있엉ㅋㅋㅋ" },
        { answer: "하이하이!" },
        { answer: false, stickerIndex: 22, stickerCat: 'bear' },
        { answer: "ㅠㅠㅠ가기싫어ㅠㅜㅠ" },
        { answer: "그래! 뭐하고 놀까?" },
        { answer: "(외면)" },
        { answer: "고고고고 곧 들어감!" },
        { answer: "나랑 놀자!" },
        { answer: "잘자~~굳밤~~" },
        { answer: "나랑 같이 놀자!" },
        { answer: "ㅠㅠㅠㅠ안돼애애" },
        { answer: "ㅋㅋㅋㅋㅋ아 웃곀ㅋㅋㅋ" },
        { answer: false, stickerIndex: 14, stickerCat: 'bear' },
      ],
      bear: [
        { answer: "맛점하세요~~^^" },
        { answer: false, stickerIndex: 20, stickerCat: 'bird' },
        { answer: false, stickerIndex: 19, stickerCat: 'bird' },        
        { answer: "네~ 나중에 연락주세요!" },
        { answer: false, stickerIndex: 20, stickerCat: 'bird' },
        { answer: false, stickerIndex: 2, stickerCat: 'bird' },     
        { answer: "안녕하세요~" },
        { answer: false, stickerIndex: 2, stickerCat: 'bird' },     
        { answer: false, stickerIndex: 13, stickerCat: 'bird' },     
        { answer: false, stickerIndex: 19, stickerCat: 'bear' },     
        { answer: false, stickerIndex: 15, stickerCat: 'bear' },     
        { answer: false, stickerIndex: 5, stickerCat: 'bear' },     
        { answer: false, stickerIndex: 20, stickerCat: 'bird' },     
        { answer: "괜찮아요ㅠㅠ" },
        { answer: false, stickerIndex: 8, stickerCat: 'bear' },
      ]
    }
  },
  methods: {
    setTab(tabName) {
      this.currentTab = ['bear', 'bird'].includes(tabName) ? tabName : this.currentTab
    },
    wait(ms=500) {
      return new Promise((res)=> {
        setTimeout(()=> res(true), ms)
      })
    },
    async selectMessage(i) {
      if (this.isLoading) return
      this.isLoading = true
      this.messages.push({
        lastMessageId: this.lastMessageId,
        isMe: true,
        stickerCat: this.currentTab,
        stickerIndex: i
      })
      this.lastMessageId += 1
      await this.wait()
      this.messages.push({
        lastMessageId: this.lastMessageId,
        isMe: false,
        ...this[this.currentTab][i - 1]
      })
      this.lastMessageId += 1
      this.isLoading = false
    }
  },
  components: {
    svgStatusBarIcons,
    DemoChat,
    DemoEmoji
  }
}
</script>

<style lang="scss" scoped>

.demo-outer {
  --demo-width: 646px;
  --demo-height: 626px;
  position: relative;
  width: var(--demo-width);
  height: var(--demo-height);
  margin: 60px auto 0;
  max-width: 100%;

  @media screen and (max-width: 768px) {
    --demo-width: 474px;
    --demo-height: 461px;
  }
  @media screen and (max-width: 420px) {
    width: calc(100%);
    max-width: calc(100%);
    // margin: 0 calc(var(--app-gutter-size) * -1);
  }
}

.demo {
  position: relative;
  border-radius: 20px;
  box-shadow: 10px 12px 29px rgba(0, 0, 0, 0.12);
  top: 0;
  left: 0;
  width: 100%;
  height: 732px;
  z-index: 5;
  background-color: white;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  @media screen and (max-width: 768px) {
    height: 580px;
  }
  @media screen and (max-width: 420px) {
    height: 540px
  }
}

.demo-head {
  background-color: #363A44;
  padding-top: 15px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}

.demo-body {
  position: relative;
  flex: 1;
  background-color: #F6F6F6;
  overflow: hidden;
}

.status-bar {
  padding: 0 24px;
  display: flex;
  justify-content: flex-end;
  svg {
    display: block;
    width: auto;
    height: 16px;
  }
}
.title-bar {
  padding: 0 16px 10px;
  display: flex;
  align-items: center;
  svg {
    display: block;
    width: 24px;
    height: auto;
  }
}
.title-bar .title {
  font-weight: 500;
  font-size: 16px;
  line-height: 21px;
  color: #FFF;
  margin-left: 6px;
}

</style>